import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EquipmentCategory } from "dora-contracts";
import { EquipmentType } from "../../data/equipment-types/types";
import * as dataActions from "../../data/equipment-types";

const prefix = "app/equipment-type-dialog";

export type FormData = {
  id?: string;
  name: string;
  category: EquipmentCategory;
  isNumbered: boolean;
  canBeEmptied: boolean;
  defaultDailyPrice: string | null;
  defaultWeeklyPrice: string | null;
  defaultMonthlyPrice: string | null;
  defaultDeliveryFee: string | null;
  defaultPickupFee: string | null;
  defaultEmptyingPrice: string | null;
  color: string | null;
  icon: string | null;
  note: string | null;
  rentalProductId: string | null;
  emptyingProductId: string | null;
  returnProductId: string | null;
};

type State = {
  open: boolean;
  initialFormData: FormData | null;
};

const initialState: State = {
  open: false,
  initialFormData: null,
};

export const getEmptyFormData = (): FormData => ({
  name: "",
  category: "CONTAINER",
  isNumbered: true,
  canBeEmptied: false,
  defaultDailyPrice: null,
  defaultWeeklyPrice: null,
  defaultMonthlyPrice: null,
  defaultDeliveryFee: null,
  defaultPickupFee: null,
  defaultEmptyingPrice: null,
  color: null,
  icon: null,
  note: null,
  rentalProductId: null,
  emptyingProductId: null,
  returnProductId: null,
});

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    addEquipmentType(state) {
      state.open = true;
      state.initialFormData = getEmptyFormData();
    },
    editEquipmentType(state, action: PayloadAction<EquipmentType>) {
      state.open = true;
      state.initialFormData = { ...action.payload };
    },
    close(state) {
      state.open = false;
      state.initialFormData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dataActions.addEquipmentType.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
    builder.addCase(dataActions.updateEquipmentType.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
  },
});

export default slice.reducer;
export const { addEquipmentType, editEquipmentType, close } = slice.actions;
